import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { Box, FlatList } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';

import { InfoItem } from '../InfoItem';

import { formatMovementData } from './contants';

import { MovementItemResponsiveProps } from '.';

const style = StyleSheet.create({
  flatlist: {
    rowGap: 16,
  },
});

export const MovementItemTablet: React.FC<MovementItemResponsiveProps> = (props) => {
  const data = formatMovementData(props);
  const numColumns = 5;

  return (
    <VStack py={Spacing['inline.xxxs']} space={Spacing['inline.nano']}>
      <FlatList
        data={data}
        numColumns={numColumns}
        style={style.flatlist}
        showsVerticalScrollIndicator={false}
        keyExtractor={(item, index) => `${item.value}-${index}`}
        renderItem={({ item, index }) => {
          const isLastOfLine = (index + 1) % numColumns === 0;

          return (
            <Box {...(!isLastOfLine && { flex: 1 })} minW={'120px'}>
              <InfoItem {...item} />
            </Box>
          );
        }}
      />
    </VStack>
  );
};
